import React from 'react';
import { useSelector } from 'react-redux';
import { getPlayerMatchupState } from '../store/selectors/playerMatchupSelector';
import PlayerMatchup from '../PlayerMatchup';

const PlayerMatchupDataContainer = (props) => {
    const playerMatchupState = useSelector(getPlayerMatchupState);
    return (
        <PlayerMatchup { ...playerMatchupState } { ...props } />
    );
};

export default PlayerMatchupDataContainer;
